import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Link, Stack, Text } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { Phone } from '@mui/icons-material';
import { useContext } from 'react';

export const Header = () => {
  const {
    data: { supportPhone },
    images: { brandLogo },
  } = useContext(AppConstants);
  const { isMobile } = useScreenSize();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <img src={brandLogo} alt="brand logo" height={30} width={150} />
      <Stack direction="row" spacing={1} alignItems="center">
        {isMobile ? <Phone /> : <Text variant="body1">Questions? Call</Text>}
        <Text variant="body1">
          <Link
            href={`tel:${supportPhone}`}
            target="_blank"
            rel="noopener noreferrer"
            color="text.primary"
          >
            {supportPhone}
          </Link>
        </Text>
      </Stack>
    </Stack>
  );
};
